import React from 'react';
import DataTable from 'react-data-table-component';
import { Calendar, Mail, Phone, Building } from 'lucide-react';
import { tableStyles } from '../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../i18n';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../utils/common';

// New status constants
const NEW = 'N';
const WAITING_FOR_TRAINING = 'WT';
const WAITING_FOR_SITEVISIT = 'WS';
const COMPLETED = 'C';

const statuses = {
  [NEW]: 'New',
  [WAITING_FOR_TRAINING]: 'Waiting for Training',
  [WAITING_FOR_SITEVISIT]: 'Waiting for Site Visit',
  [COMPLETED]: 'Completed',
};

const statusColors = {
  [NEW]: '#3b82f6', // blue-500
  [WAITING_FOR_TRAINING]: '#f59e0b', // amber-500
  [WAITING_FOR_SITEVISIT]: '#8b5cf6', // violet-500
  [COMPLETED]: '#10b981', // emerald-500
};

const StatusBadge = ({ status }) => {
  const color = statusColors[status] || '#6b7280';
  const text = statuses[status] || i18n.t('unknown_status');

  return (
    <span
      style={{
        backgroundColor: `${color}15`,
        color: color,
        padding: '4px 12px',
        borderRadius: '0.3rem',
        fontSize: '12px',
        letterSpacing: '0.025em',
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  );
};

export class SiteVisitRequestsTable extends React.Component {
  constructor() {
    super();
    this.state = {
      copiedId: null,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
  }

  handlePageChange = (page) => {
    if (this.props.onChangePage) {
      this.props.onChangePage(page);
    }
  };

  handleRowsPerPageChange = (newLimit, page) => {
    if (this.props.onChangeRowsPerPage) {
      this.props.onChangeRowsPerPage(newLimit);
    }
  };

  handleRowClick = (row, e) => {
    // Navigate to details page when row is clicked
    if (this.props.history && row.id) {
      this.props.history.push(`/site-visit-requests/${row.id}/edit`);
    } else {
    }
  };

  handleEdit = (form, e) => {
    e?.stopPropagation(); // Prevent row click when editing
    // Navigate to edit page
    if (this.props.history && form.id) {
      this.props.history.push(`/site-visit-requests/${form.id}/edit`);
    }
  };

  handleDelete = (form, e) => {
    e?.stopPropagation(); // Prevent row click when deleting
    // this.props.onDeleteForm(form);
  };

  handleView = (form, e) => {
    e?.stopPropagation(); // Prevent row click when viewing
    // this.props.onViewForm(form);
  };

  handleApprove = (form, e) => {
    e?.stopPropagation(); // Prevent row click when approving

    // this.props.onApproveForm(form);
  };

  handleReject = (form, e) => {
    e?.stopPropagation(); // Prevent row click when rejecting

    // this.props.onRejectForm(form);
  };

  handleViewFile = (fileUrl) => {
    this.props.history.push(`/site-visit-requests/${fileUrl.id}/edit`);
  };

  copyFormUrl = async (formUrl, formId, e) => {
    e?.stopPropagation(); // Prevent row click when copying
    try {
      const fullUrl = `${process.env.REACT_APP_BASE_URL}site-visit?form_url=${formUrl}`;
      await navigator.clipboard.writeText(fullUrl);

      this.setState({ copiedId: formId });

      setTimeout(() => {
        this.setState({ copiedId: null });
      }, 2000);
    } catch (err) {
      console.error('Failed to copy form URL: ', err);
      const textArea = document.createElement('textarea');
      textArea.value = `${process.env.REACT_APP_BASE_URL}site-visit?form_url=${formUrl}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.setState({ copiedId: formId });
      setTimeout(() => {
        this.setState({ copiedId: null });
      }, 2000);
    }
  };

  getTest = () => {};

  getColumns() {
    this.getTest = this.getTest.bind(this);
    const { currentPage = 1, limit = 15 } = this.props;

    const baseColumns = [
      {
        name: '#',
        width: '70px',
        button: true,
        sortable: false,
        cell: (_, index) => (currentPage - 1) * limit + (index + 1),
      },
      {
        name: i18n.t('Visitor Name'),
        sortable: true,
        width: '180px',
        button: true,

        cell: (row) => (
          <Link className="btn-new" to={`/site-visit-requests/${row.id}/edit`}>
            <div style={{ fontSize: '13px', fontWeight: '500' }} onClick={this.handleEdit(row)}>
              {row.name}
            </div>
          </Link>
        ),
      },

      // {
      //   name: 'Visitor Name',
      //   width: '150px',
      //   minWidth: '150px',
      //   maxWidth: '150px',
      //   center: true,
      //   cell: (row) => (
      //     <div className="btn-group btn-group-sm" style={{ gap: '4px' }}>
      //       <button
      //         type="button"
      //         className="btn-new btn-action"
      //         onClick={() => this.handleViewFile(row)}
      //         title="View File"

      //       >
      //         {row.name}    <Eye size={14} />
      //       </button>

      //     </div>
      //   ),
      // },

      {
        name: i18n.t('Contact Info'),
        sortable: false,
        width: '200px',
        cell: (row) => (
          <div style={{ fontSize: '12px' }}>
            <div className="d-flex align-items-center mb-1" onClick={this.getTest()}>
              <Mail size={12} className="me-1" />
              {row.email}
            </div>
            <div className="d-flex align-items-center">
              <Phone size={12} className="me-1" />
              {row.mobile}
            </div>
          </div>
        ),
      },
      {
        name: i18n.t('Status'),
        sortable: true,
        width: '160px',
        center: true,
        cell: (row) => <StatusBadge status={row.status} />,
      },
      {
        name: i18n.t('Company'),
        sortable: true,
        width: '120px',
        cell: (row) => (
          <div className="d-flex align-items-center">
            <Building size={14} className="me-1" />
            {row.company_name || '-'}
          </div>
        ),
      },
      {
        name: i18n.t('Project'),
        sortable: true,
        width: '150px',
        cell: (row) => <div style={{ fontSize: '13px' }}>{row.project?.project_name || '-'}</div>,
      },
      {
        name: i18n.t('Training Date'),
        sortable: true,
        width: '130px',
        cell: (row) => (
          <div className="d-flex align-items-center">
            <Calendar size={14} className="me-1" />
            {formatDate(row.training_date)}
          </div>
        ),
      },
      {
        name: i18n.t('Visit Date/Time'),
        sortable: true,
        width: '160px',
        cell: (row) => (
          <div style={{ fontSize: '12px' }}>
            {row.visit_date ? (
              <div>
                <div className="d-flex align-items-center">
                  <Calendar size={12} className="me-1" />
                  {formatDate(row.visit_date)}
                </div>
              </div>
            ) : (
              '-'
            )}
          </div>
        ),
      },
      {
        name: i18n.t('Submitted'),
        sortable: true,
        width: '150px',
        cell: (row) => <div style={{ fontSize: '12px' }}>{formatDate(row.created_at)}</div>,
      },
      // {
      //   name: i18n.t('Actions'),
      //   width: '200px',
      //   center: true,
      //   button: true,

      //   cell: (row) => (
      //     <div className="d-flex align-items-center justify-content-center gap-2">
      //       <Tooltip
      //         icon={Eye}
      //         tooltipText={i18n.t('view_form')}
      //         onClick={(e) => this.handleView(row, e)}
      //         size={16}
      //         className="text-primary"
      //       />

      //       {/* Show approve/reject only for NEW status */}
      //       {row.status === NEW && (
      //         <>
      //           <Tooltip
      //             icon={Check}
      //             tooltipText={i18n.t('approve_form')}
      //             onClick={(e) => this.handleApprove(row, e)}
      //             size={16}
      //             className="text-success"
      //           />
      //           <Tooltip
      //             icon={X}
      //             tooltipText={i18n.t('reject_form')}
      //             onClick={(e) => this.handleReject(row, e)}
      //             size={16}
      //             className="text-danger"
      //           />
      //         </>
      //       )}

      //       {/* Allow editing for non-completed statuses */}
      //       {row.status !== COMPLETED && (
      //         <Tooltip
      //           icon={Edit}
      //           tooltipText={i18n.t('edit_form')}
      //           onClick={(e) => this.handleEdit(row, e)}
      //           size={16}
      //           className="text-warning"
      //         />
      //       )}

      //       <Tooltip
      //         icon={Trash2}
      //         tooltipText={i18n.t('delete_form')}
      //         onClick={(e) => this.handleDelete(row, e)}
      //         size={16}
      //         className="text-danger"
      //       />
      //     </div>
      //   ),
      // },
    ];

    return baseColumns;
  }

  render() {
    const { siteVisits = [], currentPage = 1, limit = 15, total = 0 } = this.props;

    const customTableStyles = {
      ...tableStyles,
      rows: {
        ...tableStyles.rows,
        style: {
          ...tableStyles.rows?.style,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#f8f9fa',
          },
        },
      },
    };

    return (
      <>
        <DataTable
          key={`${currentPage}-${limit}`}
          title=""
          columns={this.getColumns()}
          data={siteVisits}
          customStyles={customTableStyles}
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={total}
          paginationPerPage={limit}
          paginationDefaultPage={currentPage}
          paginationRowsPerPageOptions={[15, 25, 50, 100]}
          paginationComponentOptions={{
            rowsPerPageText: i18n.t('rows_per_page'),
            rangeSeparatorText: i18n.t('out'),
          }}
          onChangeRowsPerPage={this.handleRowsPerPageChange}
          onChangePage={this.handlePageChange}
          onRowClicked={this.handleRowClick} // Add row click handler
        />
      </>
    );
  }
}

export { NEW, WAITING_FOR_TRAINING, WAITING_FOR_SITEVISIT, COMPLETED };
